import { Swiper } from 'swiper';
import elementExists from '../../core/utils/elementExists';

const FeaturedProducts = function () {
  const containers = document.querySelectorAll(
    '.featured-products',
  );
  if (elementExists(containers, true)) {
    containers.forEach(function (container) {
      const swiperContainer = container.querySelector('.swiper');
      let btnNext = container.querySelector('.swiper-button-next');
      let btnPrev = container.querySelector('.swiper-button-prev');
      const swiper = new Swiper(swiperContainer, {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    });
  }
};

export default FeaturedProducts;
